module.exports = __webpack_public_path__ + "static/media/Trainicon02.8b2c7b53.png";